<template>
  <div>
    <el-dialog
      v-if="visible"
      fullscreen
      custom-class="cs-fullscreen-dialog"
      :visible.sync="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
    >
      <Main
        ref="main"
        :shipmentCode="shipmentCode"
        :shipmentNo="shipmentNo"
        @close="close"
        @reload="$emit('reload')"
      />
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'

export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentNo: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('reload')

      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
/* 仅覆盖分柜管理全屏弹框 */
.cs-fullscreen-dialog {
  .el-dialog__header {
    display: none !important;
    padding: 0 !important;
    height: 0 !important;
  }
  .el-dialog__body {
    padding: 0 !important;
    height: 100%;
    overflow: hidden !important;
  }
}
</style>
